<style scoped>
	.topimg{
		position: relative;
		overflow: hidden;
	}
	.topPart{
		z-index: 10;
	}
	.topPart .title{
		position: absolute;
		top:50%;
		left: 50%;
		margin-top: -21px;
		margin-left: -202px;
	}
	.topPart .topimg .topbar{
		z-index: 1;
		background-size:contain|cover;
		height: 80px;
		width:100%;

		/*height: auto;*/
	}
	.topPart .titright{
		position: absolute;
		right:150px;
		/*top:50%;*/
		margin-top:-80px;
	}
	.topPart .titright img{
		background-size:contain|cover;

		width:100%;

		height: auto;
	}
	.vessel{
		height: 100%;
		width:100%;
		margin-bottom: -21px;
	}
	.vessel img{
		background-size:contain|cover;

		width:100%;

		height: auto;
		/*margin-top: -20px;*/
	}
	.centerPart{
		/*position:relative;*/
		/*margin-top: -200px;*/
		/*top:-50%;*/
	}
	.centerPart .bottomLeft{
		/*float: left;*/
		position: absolute;
		top:50%;
		margin-top: -120px;
		left: 50%;
		margin-left:-320px;
		/*z-index: 10;*/
	}
	.centerPart .bottomRight .bottomright_top{
		position: absolute;
		top: 50%;
		margin-top:-120px;
		left: 50%;
		margin-left: 0px;
	}
		.centerPart .bottomRight .bottomright_bottom{
		position: absolute;
		top: 50%;
		margin-top:60px;
		left: 50%;
		margin-left: 0px;
	}
	.bottomLeft .house{
		margin-left: -200px;
		margin-top: -60px;
	}
	.bottomLeft .insReport{
		margin-left: 100px;
		color: #f5f5f5;
		font-size: 20px;
		margin-top: -110px;
	}
	.cart{
		margin-left: -200px;
		margin-top: -30px;
	}
	.pick{
		margin-left: 105px;
		margin-top: -50px;
		color: #f5f5f5;
		font-size: 20px;
	}
	.process{
		margin-left: -200px;
		margin-top: -30px;
	}
	.Wanprocess{
		margin-left: 105px;
		margin-top: -50px;
		color: #f5f5f5;
		font-size: 20px;
	}
	.titlt img{
		height: 80px;
	}
	.allpage{
		margin-bottom: 0px;
	}
</style>
<template>
	<div class="allpage">
		<div class="allpages">
			<div class="topPart">
				<div class="topimg">
					<img src="../assets/topbarbg(1).jpg" alt="" class="topbar">
					<div class="title">
						<img src="../assets/font.png" alt="">
					</div>
					<div class="titright">
					<img src="../assets/mans.png" alt="">
					</div>
				</div>
			</div>


		<div class="bottomPart">
			<div class="vessel">
				<img src="../assets/background.jpg" alt="">
			</div>
			<div class="centerPart">
				<div class="bottomLeft" @click='stepone()'>
					<img src="../assets/sq1.png" alt="">
					<img src="../assets/wyckc.png" alt="" class="house">
					<p class="insReport">{{language.woyaochakucun}}</p>
				</div>
				<div class="bottomRight">
					<div class="bottomright_top" @click='stepTwo'>
						<img src="../assets/sq2.png" alt="">
						<img src="../assets/wyth.png" alt="" class="cart">
						<p class="pick">{{language.woyaotihuo}}</p>
					</div>
					<div class="bottomright_bottom" @click='stepThree'>
						<img src="../assets/sq3.png" alt="">
						<img src="../assets/wyjg.png" alt="" class="process">
						<p class="Wanprocess">{{language.woyaojiagong}}</p>
					</div>
				</div>
			</div>
		
		</div>
	</div>
		</div>

</template>
<script>
  	import language from 'api/language'
	export default{
		data(){
			return{
				language:{},
			}
		},
		methods:{
			stepone(){
				this.$router.push({name: 'addmeau',params:{ id:'1'}});
			},
			stepTwo(){
				this.$router.push({name: 'delivery',params:{ id:'1'}});
			},
			stepThree(){
				this.$router.push({name: 'addDingDan',params:{ id:'1'}});
			},
	     	 RefreshOnce:function(){
	         	var url = location.href; //把当前页面的地址赋给变量 url

	         	var times = url.split("?"); //分切变量 url 分隔符号为 "?"

	          	if (times[1] != 1) { //如果?后的值不等于1表示没有刷新

	              	url += "?1"; //把变量 url 的值加入 ?1

              		self.location.replace(url); //刷新页面

	          	}
	      	},
		},
		mounted(){
			this.language=language
			// this.RefreshOnce()
		}
	}
</script>


// WEBPACK FOOTER //
// firstpage.vue?33c5904f